export default "__VITE_ASSET__DVX68BQB__"